import React, { useContext, useState } from "react";
import {
  Item,
  Button,
  Label,
  Segment,
  Table,
  Menu,
  Icon,
  Dropdown,
  Confirm,
  Container,
  Tab,
  Divider,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import MobileStore from "../../../app/stores/mobileStore";
import { Link } from "react-router-dom";

const MobileList: React.FC = () => {
  const mobileStore = useContext(MobileStore);
  const {
    projectsByDate: projectsByDate,
    deleteProject: deleteProject,
    customerRegistry,
    projectRegistry,
    selectMobileTitle,
    setActiveListTab,
    activeListTab,
    submitting,
    target,
  } = mobileStore;

  const [open, setOpen] = useState(false);
  const [projectId, setProjectId] = useState("");

  const categoryList  = Array.from(projectRegistry.values()).map((project) => {
    return project["category"];
  });
  const categorys = categoryList.filter(function(item, pos) {
    return categoryList.indexOf(item) == pos;
  })
  categorys.unshift('ALL');

  const customerList  = Array.from(projectRegistry.values()).map((project) => {
    return project["customerId"];
  });
  const customers = customerList.filter(function(item, pos) {
    return customerList.indexOf(item) == pos;
  })
  customers.unshift('ALL');

  const worktypeList  = Array.from(projectRegistry.values()).map((project) => {
    return project["workType"];
  });
  const worktypes = worktypeList.filter(function(item, pos) {
    return worktypeList.indexOf(item) == pos;
  })
  worktypes.unshift('ALL');

  // const status = [
  //   "Quotes Not Yet Submitted",
  //   "Orders Not Yet Accepted",
  //   "Work in Progress",
  //   "Variation Items Not Yet Submitted",
  //   "Customer Response to Variation Request",
  //   "Work Completed",
  //   "Work Submitted",
  //   "Progress Claim Request Disputed by Customer",
  //   "Orders Stopped",
  //   "Invoiced",
  // ];

  // let countOfQuotes = 0;
  // let countOfOrders = 0;
  // let countOfWorkinProgress = 0;
  // let countOfVariation = 0;
  // let countOfCustomer = 0;
  // let countOfWorkCompleted = 0;
  // let countOfWorkSubmitted = 0;
  // let countOfProgress = 0;
  // let countOfOrdersStopped = 0;
  // let countOfInvoiced = 0;
  // projectsByDate.map(proj => {
  //   if (proj.status === 'Quotes Not Yet Submitted') countOfQuotes ++; 
  //   if (proj.status === 'Orders Not Yet Accepted') countOfOrders ++; 
  //   if (proj.status === 'Work in Progress') countOfWorkinProgress ++; 
  //   if (proj.status === 'Variation Items Not Yet Submitted') countOfVariation ++; 
  //   if (proj.status === 'Customer Response to Variation Request') countOfCustomer ++; 
  //   if (proj.status === 'Work Completed') countOfWorkCompleted ++; 
  //   if (proj.status === 'Work Submitted') countOfWorkSubmitted ++; 
  //   if (proj.status === 'Progress Claim Request Disputed by Customer') countOfProgress ++; 
  //   if (proj.status === 'Orders Stopped') countOfOrdersStopped ++; 
  //   if (proj.status === 'Invoiced') countOfInvoiced ++; 
  // })
  
  // const panes = status.map((stat) => {
  //   return {
  //   menuItem: ( (stat === 'Quotes Not Yet Submitted') ? <Menu.Item>
  //     <p><strong style={{color: 'purple'}}>Quotes</strong><Label>{countOfQuotes}</Label></p>
  //     <br/>
  //     <p>Not Yet</p>
  //     <p><strong style={{color: 'purple'}}>Submitted</strong></p>
  //     </Menu.Item> : 
  //               (stat === 'Orders Not Yet Accepted') ? <Menu.Item>
  //                 <strong style={{color: 'purple'}}>Orders Not Yet Accepted</strong><Label>{countOfOrders}</Label></Menu.Item> : 
  //               (stat === 'Work in Progress') ? <Menu.Item>
  //                 <strong style={{color: 'purple'}}>Work in Progress</strong><Label>{countOfWorkinProgress}</Label></Menu.Item> : 
  //               (stat === 'Variation Items Not Yet Submitted') ? <Menu.Item>
  //                 <strong style={{color: 'purple'}}>Variation Items Not Yet Submitted</strong><Label>{countOfVariation}</Label></Menu.Item> : 
  //               (stat === 'Customer Response to Variation Request') ? <Menu.Item>
  //                 <strong style={{color: 'purple'}}>Customer Response to Variation Request</strong><Label>{countOfCustomer}</Label></Menu.Item> : 
  //               (stat === 'Work Completed') ? <Menu.Item>
  //                 <strong style={{color: 'purple'}}>Work Completed</strong><Label>{countOfWorkCompleted}</Label></Menu.Item> : 
  //               (stat === 'Work Submitted') ? <Menu.Item>
  //                 <strong style={{color: 'purple'}}>Work Submitted</strong><Label>{countOfWorkSubmitted}</Label></Menu.Item> : 
  //               (stat === 'Progress Claim Request Disputed by Customer') ? <Menu.Item>
  //                 <strong style={{color: 'purple'}}>Progress Claim Request Disputed by Customer</strong><Label>{countOfProgress}</Label></Menu.Item> : 
  //               (stat === 'Orders Stopped') ? <Menu.Item>
  //               <strong style={{color: 'purple'}}>Orders Stopped</strong><Label>{countOfOrdersStopped}</Label></Menu.Item> : 
  //               (stat === 'Invoiced') ? <Menu.Item>
  //               <strong style={{color: 'purple'}}>Invoiced</strong><Label>{countOfInvoiced}</Label></Menu.Item> : 
  //     ''),
  //     render: () => (
  //  <Table celled>
  //   <Table.Header>
  //     <Table.Row>
  //       <Table.HeaderCell>Project Code</Table.HeaderCell>
  //       <Table.HeaderCell>
  //       <Dropdown text='Category'>
  //       <Dropdown.Menu>
  //         <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
  //         <Dropdown.Divider/>
  //       {categorys.map((category) => 
  //          <Dropdown.Item
  //            name='category'
  //            onClick={(e, { name }) =>
  //            selectMobileTitle(name, category)
  //           }
  //          >
  //            {category}
  //          </Dropdown.Item>)}
  //         </Dropdown.Menu>
  //       </Dropdown>
  //       </Table.HeaderCell>
  //       <Table.HeaderCell>
  //       <Dropdown text='Customer'>
  //       <Dropdown.Menu>
  //         <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
  //         <Dropdown.Divider/>
  //       {customers.map((customer) => 
  //          <Dropdown.Item
  //            name='customerId'
  //            onClick={(e, { name }) =>
  //            selectMobileTitle(name, customer)
  //           }
  //          >
  //            {(customer === 'ALL') ? customer : customerRegistry.get(customer).name}
  //          </Dropdown.Item>)}
  //         </Dropdown.Menu>
  //       </Dropdown>
  //       </Table.HeaderCell>
  //       <Table.HeaderCell>
  //       <Dropdown text='Work Type'>
  //       <Dropdown.Menu>
  //         <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
  //         <Dropdown.Divider/>
  //       {worktypes.map((worktype) => 
  //          <Dropdown.Item
  //            name='workType'
  //            onClick={(e, { name }) =>
  //            selectMobileTitle(name, worktype)
  //           }
  //          >
  //            {worktype}
  //          </Dropdown.Item>)}
  //         </Dropdown.Menu>
  //       </Dropdown>
  //       </Table.HeaderCell>
  //       <Table.HeaderCell>Site Id</Table.HeaderCell>
  //       <Table.HeaderCell>Site Name</Table.HeaderCell>
  //       <Table.HeaderCell >Status</Table.HeaderCell>
  //       <Table.HeaderCell width={1}>Action</Table.HeaderCell>
  //     </Table.Row>
  //   </Table.Header>

  //   <Table.Body>
  //     {projectsByDate.map((project) => (
  //      <Table.Row key={project.id}>
  //         <Table.Cell>
  //           <strong>{project.projectCode}</strong>
  //         </Table.Cell>
  //         <Table.Cell>{project.category}</Table.Cell>
  //         <Table.Cell><Link to={`/dailymanagement/customer/${project.customerId}`} style={{ color: "blue" }}>
  //           {customerRegistry.get(project.customerId).name}</Link></Table.Cell>
  //         <Table.Cell>{project.workType}</Table.Cell>
  //         <Table.Cell><Link to={`/projectmanagement/sitevodafone?siteid=${project.siteId}`} style={{ color: "blue" }}>
  //           {project.siteId}</Link></Table.Cell>
  //         <Table.Cell>{project.siteName}</Table.Cell>
  //         <Table.Cell>{project.status}</Table.Cell>
  //         <Table.Cell>
  //           <Button.Group size="mini">
  //             <Button
  //               as={Link}
  //               to={`/projectmanagement/mobile/${project.id}`}
  //               size="mini"
  //               icon="zoom in"
  //               color="blue"
  //               title="View"
  //             />
  //             <Button
  //               name={project.id}
  //               size="mini"
  //               loading={target === project.id && submitting}
  //               //onClick={(e) => deleteProject(e, project.id)}
  //               onClick={() => {
  //                 setOpen(true);
  //                 setProjectId(project.id);
  //               }}
  //               icon="delete"
  //               color="red"
  //               title="Delete"
  //             />
  //             <Confirm
  //               open={open}
  //               onCancel={() => setOpen(false)}
  //               onConfirm={(e) => {
  //                 deleteProject(projectId);
  //                   setOpen(false);
  //               }}
  //               content="Are you sure you want to delete ?"
  //               confirmButton="Yes"
  //               size="mini"
  //               style={{
  //                 position: "relative",
  //                 maxHeight: "150px",
  //                 height: "auto",
  //               }}
  //             />
  //           </Button.Group>
  //         </Table.Cell>
  //       </Table.Row>
  //     ))}
  //   </Table.Body>
  // </Table> 
  //     ),
  //   };
  // });

    return (
    <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Project Code</Table.HeaderCell>
        <Table.HeaderCell>
        <Dropdown text='Category'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {categorys.map((category) => 
           <Dropdown.Item
             name='category'
             onClick={(e, { name }) =>
             selectMobileTitle(name, category)
            }
           >
             {category}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
        <Table.HeaderCell>
        <Dropdown text='Customer'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {customers.map((customer) => 
           <Dropdown.Item
             name='customerId'
             onClick={(e, { name }) =>
             selectMobileTitle(name, customer)
            }
           >
             {(customer === 'ALL') ? customer : customerRegistry.get(customer).name}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
        <Table.HeaderCell>
        <Dropdown text='Work Type'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {worktypes.map((worktype) => 
           <Dropdown.Item
             name='workType'
             onClick={(e, { name }) =>
             selectMobileTitle(name, worktype)
            }
           >
             {worktype}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
        <Table.HeaderCell>Site Id</Table.HeaderCell>
        <Table.HeaderCell>Site Name</Table.HeaderCell>
        <Table.HeaderCell >Status</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {projectsByDate.map((project) => (
       <Table.Row key={project.id}>
          <Table.Cell>
            <strong>{project.projectCode}</strong>
          </Table.Cell>
          <Table.Cell>{project.category}</Table.Cell>
          <Table.Cell><Link to={`/dailymanagement/customer/${project.customerId}`} style={{ color: "blue" }}>
            {customerRegistry.get(project.customerId).name}</Link></Table.Cell>
          <Table.Cell>{project.workType}</Table.Cell>
          <Table.Cell><Link to={`/projectmanagement/sitevodafone?siteid=${project.siteId}`} style={{ color: "blue" }}>
            {project.siteId}</Link></Table.Cell>
          <Table.Cell>{project.siteName}</Table.Cell>
          <Table.Cell>{project.status}</Table.Cell>
          <Table.Cell>
            <Button.Group size="mini">
              <Button
                as={Link}
                to={`/projectmanagement/mobile/${project.id}`}
                size="mini"
                icon="zoom in"
                color="blue"
                title="View"
              />
              <Button
                name={project.id}
                size="mini"
                loading={target === project.id && submitting}
                //onClick={(e) => deleteProject(e, project.id)}
                onClick={() => {
                  setOpen(true);
                  setProjectId(project.id);
                }}
                icon="delete"
                color="red"
                title="Delete"
              />
              <Confirm
                open={open}
                onCancel={() => setOpen(false)}
                onConfirm={(e) => {
                  deleteProject(projectId);
                    setOpen(false);
                }}
                content="Are you sure you want to delete ?"
                confirmButton="Yes"
                size="mini"
                style={{
                  position: "relative",
                  maxHeight: "150px",
                  height: "auto",
                }}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>


  </Table> )
     
    //  return (
    //   <Container fluid>
    //     <Tab 
    //     panes={panes} 
    //     menu={{ pointing: true }} 
    //     onTabChange={(e, data) => setActiveListTab(Number(data.activeIndex))}
    //     defaultActiveIndex={activeListTab}
    //     />
    //   </Container>
    // );
};

export default observer(MobileList);
